export { default } from './DNAGraph';



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/DNAGraph/index.js